export const PROD_NEEDED_FULL_PALLET = "FP";

export function formatProdNeededCode(prodNeeded) {
  if (!prodNeeded) {
    return "";
  }
  const count = /^COUNT:(\d+)$/.exec(prodNeeded);
  return count ? `(COUNT ${count[1]})` : `(${prodNeeded})`;
}

export function formatItemWithProdNeeded(itemName, prodNeeded) {
  const code = formatProdNeededCode(prodNeeded);
  return code ? `${itemName} ${code}` : itemName;
}

export function parseProdNeeded(prodNeeded) {
  if (prodNeeded === PROD_NEEDED_FULL_PALLET) {
    return {
      mode: "full",
      partialRows: "",
      estimateLow: "",
      estimateHigh: "",
      count: "",
    };
  }

  const count = /^COUNT:(\d+)$/.exec(prodNeeded || "");
  if (count) {
    return {
      mode: "count",
      partialRows: "",
      estimateLow: "",
      estimateHigh: "",
      count: count[1],
    };
  }

  const estimate = /^(\d+)-(\d+)$/.exec(prodNeeded || "");
  if (estimate) {
    return {
      mode: "estimate",
      partialRows: "",
      estimateLow: estimate[1],
      estimateHigh: estimate[2],
      count: "",
    };
  }

  if (/^\d+$/.test(prodNeeded || "")) {
    return {
      mode: "partial",
      partialRows: prodNeeded,
      estimateLow: "",
      estimateHigh: "",
      count: "",
    };
  }

  return {
    mode: "full",
    partialRows: "",
    estimateLow: "",
    estimateHigh: "",
    count: "",
  };
}

export function isValidProdNumber(value) {
  const number = Number(value);
  return Number.isInteger(number) && number >= 1 && number <= 99;
}
